import {
    allowedMediaSubscriptionEnum,
    MediaSubscriptionMediaTypeEnum,
    subscriptionTypeIconMap
} from '../../../api/mediaSubscriptions/enums/media-subscription-media-type.enum';

export class MediaSubscriptionTypeModel {
    id: MediaSubscriptionMediaTypeEnum;
    name: string;
    icon: string;
    disabled: boolean;
    hidden: boolean;

    constructor(
        id: MediaSubscriptionMediaTypeEnum
    ) {
        this.id = id;
        this.name = `MediaSubscriptionType.${this.id}`;
        this.icon = subscriptionTypeIconMap.get(id);
        this.disabled = false;
        this.hidden = false;
    }

    static getAllMediaSubscriptionTypes(): MediaSubscriptionTypeModel[] {
        return Object.values(MediaSubscriptionMediaTypeEnum).map((mediaType) => {
            return new MediaSubscriptionTypeModel(mediaType);
        });
    }

    // List of allowed media types for Subscriptions, regardless of AMT provision
    static getAllowedMediaSubscriptionTypes(): MediaSubscriptionTypeModel[] {
        return Object.values(allowedMediaSubscriptionEnum).map((mediaType) => {
            return new MediaSubscriptionTypeModel(mediaType as MediaSubscriptionMediaTypeEnum);
        });
    }
}
